import { useState, useEffect } from 'react';
import $ from 'jquery';

function useExternalScript(src, id) {
  const [state, setState] = useState({
    loading: true,
    error: false
  });

  useEffect(() => {
    if (document.getElementById(id)) {
      setState({
        loading: false,
        error: false
      });
    } else {
      const script = document.createElement('script');
      script.src = src;
      script.id = id;

      const onScriptLoad = () => {
        setState({
          loading: false,
          error: false
        });
      };

      const onScriptError = () => {
        script.remove();
        setState({
          loading: true,
          error: true
        });
      };

      $.getScript(src, (response, status) => {
        if (status === 'success') {
          document.body.appendChild(script);
          onScriptLoad();
        } else if (status === 'error') {
          onScriptError();
        }
      });
    }
  }, [src, id]);

  return { loading: state.loading, error: state.error };
}

export default useExternalScript;
